<ng-multiselect-dropdown
	[ngStyle]="{'pointer-events': isDisabled ? 'none' : ''}"
	[placeholder]="placeholder"
	[data]="options"
	[(ngModel)]="selectedOptions"
	[settings]="settings"
	[disabled]="isDisabled"
	(onSelect)="onSelectOption($event)"
	(onDeSelect)="onDeselectOption($event)"
>
</ng-multiselect-dropdown>
